import React from 'react';
import { AlertCircle, Calendar, CheckCircle2, Clock, User } from 'lucide-react';
import { styles } from '../styles/styles.js';
import { calculateTaskStatistics, getWorkerStats, getWorkerStatusColor } from '../utils/utils.js';

const OverviewPage = ({ tasks, workers }) => {
    const { totalTasks, completedTasks, inProgressTasks, highPriorityTasks, completionRate } = calculateTaskStatistics(tasks);

    return (
        <div>
            <div style={styles.statsGrid}>
                <div style={styles.statCard}>
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                        <p style={{ color: "#6b7280", fontSize: "0.875rem", margin: 0 }}>Total Tasks</p>
                        <Calendar size={15} color="#6b7280" />
                    </div>
                    <p style={{ ...styles.statNumber, color: "#111827", margin: 0 }}>{totalTasks}</p>
                    <p style={{ color: "#6b7280", fontSize: "0.875rem", margin: 0 }}>Active assignments</p>
                </div>

                <div style={styles.statCard}>

                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                        <p style={{ color: '#6b7280', fontSize: '0.875rem', margin: 0 }}>Completed</p>
                        <CheckCircle2 style={{ height: "16px", width: "16px", color: "#22c55e" }} />
                    </div>
                    <p style={{ ...styles.statNumber, color: '#16a34a', margin: 0 }}>{completedTasks}</p>
                    <p style={{ color: '#6b7280', fontSize: '0.875rem', margin: 0 }}>Tasks finished</p>
                </div>

                <div style={styles.statCard}>

                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                        <p style={{ color: '#6b7280', fontSize: '0.875rem', margin: 0 }}>In Progress</p>
                        <Clock size={15} color="#d97706" />
                    </div>
                    <p style={{ ...styles.statNumber, color: '#d97706', margin: 0 }}>{inProgressTasks}</p>
                    <p style={{ color: '#6b7280', fontSize: '0.875rem', margin: 0 }}>Currently working</p>
                </div>

                <div style={styles.statCard}>
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                        <p style={{ color: '#6b7280', fontSize: '0.875rem', margin: 0 }}>High Priority</p>
                        <AlertCircle style={{ height: "16px", width: "16px", color: "#dc2626" }} />
                    </div>
                    <p style={{ ...styles.statNumber, color: '#dc2626', margin: 0 }}>{highPriorityTasks}</p>
                    <p style={{ color: '#6b7280', fontSize: '0.875rem', margin: 0 }}>Urgent tasks</p>
                </div>
            </div>
            {/* Task Completion */}
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(400px, 1fr))', gap: '2rem' }}>
                <div style={styles.card}>
                    <h3 style={styles.cardTitle}>Task Completion Rate</h3>
                    <p style={{ color: '#6b7280', marginBottom: '1rem' }}>Overall progress across all tasks</p>

                    <div style={{ marginBottom: '1rem' }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '0.5rem' }}>
                            <span style={{ fontSize: '0.875rem', color: '#6b7280' }}>Completion Progress</span>
                            <span style={{ fontSize: '0.875rem', fontWeight: '500', color: '#111827' }}>{completionRate}%</span>
                        </div>
                        <div style={styles.progressBar}>
                            <div style={{ ...styles.progressFill, width: `${completionRate}%` }}></div>
                        </div>
                    </div>

                    <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '0.875rem', color: '#6b7280' }}>
                        <span>Completed: {completedTasks}</span>
                        <span>Remaining: {totalTasks - completedTasks}</span>
                    </div>
                </div>
                {/* Staff Overview */}
                <div style={styles.card}>
                    <h3 style={styles.cardTitle}>Staff Overview</h3>
                    <p style={{ color: '#6b7280', marginBottom: '1rem' }}>Current workforce status</p>

                    <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
                        {workers.map(worker => {
                            const stats = getWorkerStats(worker.id, tasks);
                            const statusColors = getWorkerStatusColor(worker.status);
                            return (
                                <div key={worker.id} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
                                        <div style={{ ...styles.avatar, width: '2rem', height: '2rem', fontSize: '0.8rem' }}>
                                            {worker.initials}
                                        </div>
                                        <div>
                                            <p style={{ fontWeight: '500', color: '#111827', marginBottom: '0.25rem' }}>{worker.name}</p>
                                            <p style={{ fontSize: '0.875rem', color: '#6b7280' }}>{worker.role}</p>
                                        </div>
                                    </div>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
                                        <span style={{
                                            padding: '0.25rem 0.5rem',
                                            borderRadius: '0.25rem',
                                            fontSize: '0.75rem',
                                            fontWeight: '500',
                                            backgroundColor: statusColors.bg,
                                            color: statusColors.color
                                        }}>
                                            {worker.status}
                                        </span>
                                        <span style={{ fontSize: '0.875rem', color: '#6b7280' }}>{stats.total} tasks</span>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default OverviewPage;